import { StyleSheet } from 'react-native';
import { neutrals } from 'src/theme/colors';

export const styles = StyleSheet.create({
  loadingContentDetails: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    gap: 41,
  },
  loadingContentText: {
    color: neutrals.neutralGrays.cement,
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 24,
    textAlign: 'center',
  },
});
